<div class="gridListdemoDynamicTiles" fxFlex>

    <span>
        <span *ngIf="title">{{title}}</span>
        <span *ngIf="title && cardData.SubHeader"> &bull; </span>
        <span *ngIf="cardData.SubHeader">{{cardData.SubHeader}}</span>
        <span *ngIf="cardData.SubHeader && cardData.Description"> &bull; </span>
        <span *ngIf="cardData.Description"> {{cardData.Description}}</span>
    </span>

    <div fxLayout="row" layout-wrap>
        <forge-avatar *ngIf="portrait && hasPhoto" [image-url]="photoUrl">
        </forge-avatar>

        <forge-avatar *ngIf="portrait && !hasPhoto" class="noPhoto">
            <forge-icon aria-hidden="true" name="person"></forge-icon>
        </forge-avatar>

        <div *ngFor="let dataElement of elementsToShow" fxFlex>
            <labeled-field *ngIf="isCurrency(dataElement)" [label]="dataElement.Label">
                <truncate-text [mainText]="dataElement.Value | currency" [multiLine]="false">
                </truncate-text>
            </labeled-field>

            <labeled-field *ngIf="hasIcon(dataElement)" [label]="dataElement.Label" fxLayout="row">
                <mat-icon *ngIf="!usesIconSpan(dataElement.Icon)">
                    {{dataElement.Icon}}
                </mat-icon>

                <span *ngIf="usesIconSpan(dataElement.Icon)" class="tt-icon" [ngClass]="getIconSpanClass(dataElement)">
                </span>

                <span>{{dataElement.Value}}</span>
            </labeled-field>

            <labeled-field *ngIf="showLink(dataElement, true)" [label]="dataElement.Label">
                <a (click)="openTypeCommand(dataElement)" class="tt-value-link"
                   attr.telemetry="Submission-{{dataElement.Value}}">
                    {{dataElement.Value}}
                </a>
            </labeled-field>

            <labeled-field *ngIf="showLink(dataElement, false, true)" [label]="dataElement.Label">
                <a [href]="dataElement.ActionItems.ActionValue" class="tt-value-link">
                    {{dataElement.Value}}
                </a>
            </labeled-field>

            <labeled-field *ngIf="showMetadataLink(dataElement)" [label]="dataElement.Label">
                <a (click)="performMetadataAction(dataElement.ActionItems)" class="tt-value-link"
                   attr.aria-label="Action-{{dataElement.Value}}">
                    {{dataElement.Value}}
                </a>
            </labeled-field>

            <labeled-field *ngIf="showField(dataElement)" [label]="dataElement.Label">
                <truncate-text [mainText]="dataElement.Value" [allowHtml]="true" [multiLine]="true">
                </truncate-text>
            </labeled-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div style="width: 50px"></div>

        <div *ngFor="let dataElement of emailElements" fxFlex>
            <labeled-field [label]="dataElement.Label">
                <a href="mailto:{{dataElement.Value}}">
                    {{dataElement.Value}}
                </a>
            </labeled-field>
        </div>
    </div>

    <div *ngIf="chartConfig" class="mt10">
        <chartjs-container [config]="chartConfig" [heightPx]="80">
        </chartjs-container>
    </div>

    <div *ngIf="hasCardActions" fxLayout="row" fxLayoutAlign="end center">

        <div *ngFor="let action of cardData.CardActions">

            <forge-icon-button *ngIf="isIconButton(action)" [disabled]="isProcessing"
                               (click)="cardActionClicked(action)" [attr.aria-label]="getCardActionAriaLabel(action)"
                               [attr.telemetry]="getCardActionTelemetryLabel(action)">
                <forge-tooltip placement="bottom">{{action.label}}</forge-tooltip>
                <forge-icon name="{{action.icon}}" [ngStyle]="getIconStyle(action.color)">
                </forge-icon>
            </forge-icon-button>

            <forge-button *ngIf="isTextButton(action)" [disabled]="isProcessing" (click)="cardActionClicked(action)"
                          [attr.telemetry]="getCardActionTelemetryLabel(action)">

                {{action.label}}
            </forge-button>

            <forge-icon-button *ngIf="isBadgeButton(action)" (click)="cardActionClicked(action)"
                               [disabled]="isProcessing">
                <forge-tooltip placement="bottom">
                    {{action.label}}
                </forge-tooltip>

                <forge-badge *ngIf="action.Model > 0" positioned strong>
                    {{action.Model}}
                </forge-badge>
                <forge-icon [name]="action.icon">
                </forge-icon>
            </forge-icon-button>
        </div>
    </div>

    <forge-linear-progress *ngIf="isProcessing"></forge-linear-progress>
</div>
